module.exports = __webpack_public_path__ + "static/media/quem-somos.7472fde7.jpg";